import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';

export const TopUpButton = () => {
  const { openModal } = useModalContext();
  const { organization } = useAuthContext();

  if (
    !organization?.billingAccount ||
    !organization?.permissions?.viewBilling ||
    !organization?.permissions?.manageBilling
  ) {
    return null;
  }

  const openTopUpModal = () => {
    if (!organization?.permissions?.viewBilling || !organization?.permissions?.manageBilling) {
      return;
    }
    openModal(ModalNamesEnum.TopUpCreditBalance);
  };

  return (
    <div className="absolute top-[26px] right-[15px]">
      <button
        onClick={openTopUpModal}
        className="
        group border border-transparent whitespace-nowrap rounded-[5px] text-xs font-semibold leading-4
    bg-[linear-gradient(var(--color-surface),var(--color-surface)),_linear-gradient(to_right,var(--color-gradient-from),var(--color-gradient-to))]
    bg-origin-border [background-clip:padding-box,_border-box]
    hover:bg-[linear-gradient(to_right,var(--color-gradient-from),var(--color-gradient-to))] hover:[background-clip:border-box]
        "
      >
        <div
          className="
    rounded-[4px] px-[15px] py-[5px] text-xs font-semibold leading-4 whitespace-nowrap
    bg-[var(--color-surface)]
    bg-clip-text text-transparent bg-gradient-to-r from-[var(--color-gradient-from)] to-[var(--color-gradient-to)]
    group-hover:bg-transparent group-hover:text-white
  "
        >
          Top up
        </div>
      </button>
    </div>
  );
};
